var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66695 12.0026C4.47806 12.0026 4.31973 11.9387 4.19195 11.8109C4.06417 11.6832 4.00028 11.5248 4.00028 11.3359V10.0026H12.667V4.0026H14.0003C14.1892 4.0026 14.3475 4.06649 14.4753 4.19427C14.6031 4.32205 14.667 4.48038 14.667 4.66927V14.6693L12.0003 12.0026H4.66695ZM1.33362 11.3359V2.0026C1.33362 1.81372 1.39751 1.65538 1.52528 1.5276C1.65306 1.39983 1.8114 1.33594 2.00028 1.33594H10.667C10.8558 1.33594 11.0142 1.39983 11.142 1.5276C11.2697 1.65538 11.3336 1.81372 11.3336 2.0026V8.0026C11.3336 8.19149 11.2697 8.34983 11.142 8.4776C11.0142 8.60538 10.8558 8.66927 10.667 8.66927H4.00028L1.33362 11.3359ZM10.0003 7.33594V2.66927H2.66695V7.33594H10.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommu);
export default __webpack_public_path__ + "static/media/commu.9b7bb1f2a8db10f4e1b45eb7b951da6c.svg";
export { ForwardRef as ReactComponent };